import React from 'react'
import { MaterialSymbolProps } from './types'

// アイコンフォント(非同期読み込み)が適用されるまでは name がそのままテキストとして描画され、
// アイコン1文字よりはるかに広い幅を占めるため、読み込み完了時にレイアウトが動いてしまう。
// フォントサイズと同じ大きさのボックスに固定してはみ出しをクリップし、読み込み前後で幅が変わらないようにする。
// 1em にしているのは font-size をどこで指定していても(size プロパティ/style/CSS)追従させるため
const FIXED_BOX_STYLE: React.CSSProperties = {
  display: 'inline-block',
  width: '1em',
  height: '1em',
  lineHeight: 1,
  overflow: 'hidden',
}

export const StyledMaterialSymbol: React.FC<MaterialSymbolProps> = ({ name, className, style, size, onClick }) => {
  const classes=['material-symbols-outlined', className].filter(Boolean).join(' ')
  const combinedStyle = { ...FIXED_BOX_STYLE, ...style, ...(size ? { fontSize: size } : {}) }

  return (
    <span className={classes} style={combinedStyle} onClick={onClick}>{name}</span>
  )
}
